import { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import InfiniteList from '@comp/InfiniteList/InfiniteList';
import EducatorDetailedCard from '@comp/EducatorDetailedCard/EducatorDetailedCard';
import { useSelectorToStore } from '@hooks/reduxHooks';
import Drawer from '@base/Drawer/Drawer';
import H2 from '@base/H2/H2';
import { fetchLearnerFollowing } from '@actions/educator';
import { Spacings } from '@styles/index';
import { useDispatch } from 'react-redux';

const Title = styled(H2)`
  grid-column: span 10;
  color: var(--color-text-primary);
`;

const EducatorDetailedCardLinkStyle = `
  margin-top: ${Spacings.SPACING_3B};
  margin-bottom: ${Spacings.SPACING_3B};
`;

const LearnerFollowing = ({
  learnerUsername,
  showLearnerFollowing,
  onCloseLearnerFollowing,
  onClickFollow
}) => {
  const dispatch = useDispatch();

  const followingList = useSelectorToStore(
    (state) => state.paginator.learnerFollowing?.[learnerUsername]
  );

  useEffect(() => {
    dispatch(fetchLearnerFollowing(learnerUsername, false));
  }, [dispatch, learnerUsername]);

  const [isInitialLoadDone, setIsInitialLoadDone] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsInitialLoadDone(showLearnerFollowing);
    }, 10);
  }, [showLearnerFollowing]);

  const loadMoreFollowingList = () => {
    return dispatch(fetchLearnerFollowing(learnerUsername, true));
  };

  const handleOnClickFollow = (username, follow) => (e) => {
    e.preventDefault();
    if (onClickFollow) {
      onClickFollow(username, follow);
    }
  };

  const renderEducator = (user) => (
    <EducatorDetailedCard
      key={user.uid}
      educator={user}
      gridColumn="span 10"
      showFollow
      linkStyle={EducatorDetailedCardLinkStyle}
      toggleFollow={handleOnClickFollow}
    />
  );

  return (
    <Drawer
      drawerState={showLearnerFollowing}
      onClose={onCloseLearnerFollowing}
    >
      <Title>Following</Title>
      {isInitialLoadDone ? (
        <InfiniteList
          data={followingList}
          loadMore={loadMoreFollowingList}
          _renderItem={renderEducator}
          scrollElement={document.getElementById('DrawerPaper')}
        />
      ) : null}
    </Drawer>
  );
};

LearnerFollowing.propTypes = {
  learnerUsername: PropTypes.string.isRequired,
  showLearnerFollowing: PropTypes.bool.isRequired,
  onCloseLearnerFollowing: PropTypes.func.isRequired,
  onClickFollow: PropTypes.func.isRequired
};

export default LearnerFollowing;
